import { MissedConnectionDisclaimer } from "../MissedConnectionDisclaimer";
import { SelfTransferDisclaimer } from "../SelfTransferDisclaimer";

export const FlightDetailsViAlert = () => {
  return (
    <>
      <MissedConnectionDisclaimer modal />
      <SelfTransferDisclaimer modal />
    </>
  );
};
